import React from 'react';
import { Link } from 'react-router-dom';
import { resolveAvatarUrl, handleAvatarError } from '../../utils/profilePicUrl';
import { getAuthorDisplayName, formatAuthorMetaLine } from '../../utils/displayName';
import {
  postAuthorStyle,
  postMetaStyle,
  postTitleStyle,
  postTitleLinkStyle,
} from './postCardStyles';
import AuthorNameLink from './AuthorNameLink';

/**
 * Home-style post header: avatar + meta first, then title.
 */
export default function PostCardHeader({ post, API_URL, formatDate, postLink }) {
  const displayName = getAuthorDisplayName(post);
  const profileId = post.user_id;

  const avatar = (
    <img
      src={resolveAvatarUrl(post, API_URL)}
      alt="avatar"
      style={{
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginRight: '12px',
      }}
      onError={handleAvatarError}
    />
  );

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
        {profileId ? (
          <Link to={`/profile/${profileId}`} onClick={(e) => e.stopPropagation()}>
            {avatar}
          </Link>
        ) : (
          avatar
        )}
        <div>
          <div style={postAuthorStyle}>
            <AuthorNameLink user={post} style={{ fontWeight: 600 }}>
              {displayName}
            </AuthorNameLink>
          </div>
          <div style={postMetaStyle}>
            {formatAuthorMetaLine(post, formatDate)}
          </div>
        </div>
      </div>

      <h3 style={postTitleStyle}>
        {postLink ? (
          <Link to={postLink} style={postTitleLinkStyle}>
            {post.title}
          </Link>
        ) : (
          <span style={postTitleLinkStyle}>{post.title}</span>
        )}
      </h3>
    </>
  );
}
